import { useEffect } from "react";

const loadedGoogleFonts = new Map<
  string,
  { link: HTMLLinkElement; consumers: number }
>();

/**
 * Injects a Google Fonts stylesheet for Template Studio preview.
 * Shares the link across renderers and removes it after the last consumer unmounts.
 */
export const useGoogleFont = (stylesheetUrl: string | null): void => {
  useEffect(() => {
    if (stylesheetUrl === null || stylesheetUrl.length === 0) return;

    let loadedFont = loadedGoogleFonts.get(stylesheetUrl);
    if (loadedFont === undefined) {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = stylesheetUrl;
      document.head.appendChild(link);
      loadedFont = { link, consumers: 0 };
      loadedGoogleFonts.set(stylesheetUrl, loadedFont);
    }
    loadedFont.consumers += 1;

    return () => {
      loadedFont.consumers -= 1;
      if (loadedFont.consumers === 0) {
        loadedFont.link.remove();
        loadedGoogleFonts.delete(stylesheetUrl);
      }
    };
  }, [stylesheetUrl]);
};
